<template>
  <main class="ws-page">
    <header class="ws-page-header">
      <h1 class="ws-page-header__title has-text-weight-bold is-size-2" v-text="$t('Отчеты и Выгрузки')"></h1>
      <div class="ws-page-header-actions">
      </div>
    </header>
    <button class="ws-button button is-text" @click="createReport()">
      <ws-icon
        class="ws-button__icon is-position-left"
        name="plus-circle"
        :title="$t('Сформировать отчет по заявкам')"
        color="#1c3b8d"
        width="20"
        height="20"
      />
      <strong class="ws-button__text has-text-primary" v-text="$t('Сформировать отчет по заявкам')"></strong>
    </button>
  </main>
</template>

<script>
import WsReportsForm from '@/components/de/reports/WsReportsForm'

export default {
  name: 'Reports',
  methods: {
    createReport () {
      this.$buefy.modal.open({
        parent: this,
        component: WsReportsForm,
        hasModalCard: true,
        canCancel: false,
        events: {
          'onReportCreated': async report => {
          }
        }
      })
    }
  }
}
</script>
